import { render, staticRenderFns } from "./AdminInventory.vue?vue&type=template&id=1153b74c&"
import script from "./AdminInventory.vue?vue&type=script&lang=js&"
export * from "./AdminInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports